// Configuration for the @movmo/connect-button local test surface.
//
// The DCR client_id below was registered against e2e for this exact redirect
// URI. DCR carries a 30-day sliding TTL — re-register and update if expired.
// Override via env var without touching the source.

export const CONNECT_BUTTON_CLIENT_ID =
    process.env.REACT_APP_MOVMO_CONNECT_BUTTON_CLIENT_ID ||
    "b846c671-054d-4310-8202-2804558e26d5";

export const CONNECT_BUTTON_REDIRECT_URI =
    "http://localhost:3000/connect-button/callback";

// NOTE (MOVMO-526): no authorize URL here — @movmo/connect-button >=0.3.0
// derives it from isProd (unset → https://auth.e2e.movmo.io/).

// Routed through CRA's setupProxy.js → https://e2e.api.movmo.io/v1/oauth/token.
// This bypasses browser CORS — production partner integrations run this on
// their backend with client_secret, where CORS doesn't apply.
export const CONNECT_BUTTON_TOKEN_URL = "/proxy/oauth/token";
